import { render, staticRenderFns } from "./CardDetails.vue?vue&type=template&id=3217037e&"
import script from "./CardDetails.vue?vue&type=script&lang=js&"
export * from "./CardDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\takaj\\Documents\\COFOUNDRY\\okinus-ui\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3217037e')) {
      api.createRecord('3217037e', component.options)
    } else {
      api.reload('3217037e', component.options)
    }
    module.hot.accept("./CardDetails.vue?vue&type=template&id=3217037e&", function () {
      api.rerender('3217037e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/features/payasguest/screens/PayAsGuest/CardDetails.vue"
export default component.exports